import React, { useState } from "react";
import { motion } from "framer-motion";
import "./steps.css";
import { useWizard } from "react-use-wizard";
import { useDispatch } from "react-redux";
import { stepActions } from "../../store/Steps";
import mteLogo from "../../../assets/images/mtek-logo.svg";
import { useTranslation } from "react-i18next";
import playstoreMtek from "../../../assets/images/click-to-download.svg";
import { variants } from "../../shared/variants";
import { useNavigate } from "react-router-dom";
import { DOMAIN_THEME_PREFIX_BOLTTECH, DOMAIN_THEME_PREFIX_MTEK } from "../../enums/prefix";

import user2 from "../../../assets/images/user2.png";
import arrowDown from "../../../assets/images/down-arrow.png";
import powerByIcon from "../../../assets/images/powered-by-bolttech.svg";

function Steps({ name }: any) {
  const { t, i18n } = useTranslation();
  const { goToStep } = useWizard();
  const [toggle, setToggle] = useState<any>(false);
  const [isNavOpen, setIsNavOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const hostname = window.location.hostname.toLowerCase();
  const isMtekOrBolttech = hostname.includes(DOMAIN_THEME_PREFIX_MTEK) || hostname.includes(DOMAIN_THEME_PREFIX_BOLTTECH);

  const displayEmail = localStorage.getItem("email")!;
  const userEmail = sessionStorage.getItem("email")!;
  const displayName = localStorage.getItem("userName")!;
  const username = sessionStorage.getItem("userName")!;
  const dname = displayName ? displayName : username;
  const email = displayEmail ? displayEmail : userEmail;
  const isLoggedIn = Boolean(dname || email);
  const authLabel = dname || email || t("header.signIn");

  const onSignOut = () => {
    sessionStorage.removeItem("userName");
    sessionStorage.clear();
    localStorage.clear();
    dispatch(stepActions.onRestartCurrentStepToDefault()) && goToStep(0);
    window.location.reload();
  };

  const onLogoClick = () => {
    dispatch(stepActions.onRestartCurrentStepToDefault());
    sessionStorage.removeItem("payment-screen");
    sessionStorage.setItem("onGetStarted", "false");
    setIsNavOpen(false);
    goToStep(0);
  };

  const onDesktopAuthClick = () => {
    if (isLoggedIn) {
      onSignOut();
      return;
    }

    navigate("/login");
  };

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const getCurrentStepOnMobile = (stepName: string): string => {
    let step = "";
    switch (stepName) {
      case "get-started":
        step = t("steps.indicator", { current: 1 });
        return step;
      case "travel-details":
        step = t("steps.indicator", { current: 2 });
        return step;
      case "quotes":
        step = t("steps.indicator", { current: 3 });
        return step;
      case "auth":
        step = t("steps.indicator", { current: 4 });
        return step;
      case "prepare":
        step = t("steps.indicator", { current: 5 });
        return step;
      case "insured-details":
        step = t("steps.indicator", { current: 6 });
        return step;
      case "beneficiary":
        step = t("steps.indicator", { current: 7 });
        return step;
      case "group-details":
        step = t("steps.indicator", { current: 7 });
        return step;
      case "summary":
        step = t("steps.indicator", { current: 8 });
        return step;
      case "payment":
        step = t("steps.indicator", { current: 9 });
        return step;
    }
    return step;
  };
  return (
    <motion.div
      variants={variants}
      initial="enter"
      animate="center"
      className="steps-container step-1-container"
    >
      <header className="steps-header w-100">
        <nav className="navbar navbar-expand-lg steps-navbar px-0">
          <button
            type="button"
            className="navbar-brand steps-logo-btn p-0 border-0 bg-transparent"
            onClick={onLogoClick}
          >
            <img alt="Mtek logo" className="steps-logo mtek-logo" />
          </button>

          <button
            className="navbar-toggler steps-navbar-toggler ms-auto"
            type="button"
            aria-controls="stepsNavbarContent"
            aria-expanded={isNavOpen}
            aria-label="Toggle navigation"
            onClick={() => setIsNavOpen((current) => !current)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            id="stepsNavbarContent"
            className={`collapse navbar-collapse justify-content-end ${
              isNavOpen ? "show" : ""
            }`}
          >
            <div className="steps-nav-actions ms-auto d-flex align-items-center">
              <select 
                className="form-select form-select-sm me-3" 
                style={{ width: "auto" }} 
                onChange={(e) => changeLanguage(e.target.value)} 
                value={i18n.language}
              >
                <option value="en">English</option>
                <option value="sw">Kiswahili</option>
                <option value="am">Amharic</option>
              </select>
              <div
                onClick={onDesktopAuthClick}
                className="auth-mgmt-btn gap-2 d-none d-lg-inline-flex"
                title={authLabel}
              >
                <img src={user2} alt="user" />
                <span>{authLabel}</span>
              </div>
              <div
                onClick={onDesktopAuthClick}
                className="auth-mgmt-btn gap-2 d-inline-flex d-lg-none"
                title={authLabel}
              >
                <img src={user2} alt="user" />
                <span>{authLabel}</span>
              </div>
              {isMtekOrBolttech ? (
                <>
                  <a
                    href="https://bit.ly/3FprVBJ"
                    target="_blank"
                    rel="noreferrer"
                    className="steps-download-link d-none d-lg-inline-flex"
                  >
                    <div className="steps-download-content">
                      <img
                        className="steps-download-image"
                        src={playstoreMtek}
                        alt="Download on Play Store"
                      />
                      <div className="playstore-click-to-download">
                        {t("header.clickToDownload")}
                      </div>
                    </div>
                  </a>

                  <a
                    href="https://bit.ly/3FprVBJ"
                    target="_blank"
                    rel="noreferrer"
                    className="steps-download-link steps-download-link-mobile d-lg-none"
                  >
                    <div className="steps-download-content">
                      <img
                        className="steps-download-image"
                        src={playstoreMtek}
                        alt="Download on Play Store"
                      />
                      <div className="playstore-click-to-download">
                        {t("header.clickToDownload")}
                      </div>
                    </div>
                  </a>
                </>
              ) : (
                <div className="powered-by-header d-flex align-items-center ms-3">
                  <img src={powerByIcon} alt="Powered by" style={{ height: "15px" }} />
                </div>
              )}

              {/* {dname && (
                <div className="auth-mgt-wrapper">
                  <div
                    onClick={() => setToggle(!toggle)}
                    className="auth-mgmt-btn-k"
                  >
                    <img width={25} src={user2} alt="user" />
                    <span className="ms-1 me-1">{dname || ""}</span>
                    <img width={25} src={arrowDown} alt="down arrow" />
                  </div>
                  {toggle && (
                    <div className="text-center">
                      <p className="emial-p mt-2">{email || ""}</p>
                      <p
                        className="emial-p mt-2 policie-title"
                        onClick={() => {
                          navigate("/policies");
                          setIsNavOpen(false);
                        }}
                      >
                        My Policies
                      </p>
                      <div
                        className="sign-out-btn policie-title"
                        onClick={() => onSignOut()}
                      >
                        SIGN OUT
                      </div>
                    </div>
                  )}
                </div>
              )} */}
            </div>
          </div>
        </nav>
      </header>
      <p className="step-indicator step-1">{getCurrentStepOnMobile(name)}</p>
      <div className="desktop-nav">
        <div className="nav-wrapper">
          <div
            className={
              name == "get-started"
                ? "nav-step-container marked"
                : "nav-step-container"
            }
          >
            <div
              className={
                name == "get-started" ? "nav-circle active-grow" : "nav-circle"
              }
            >
              <span>1</span>
            </div>
            <br />
            <span className="step-details mt-2">
              {name == "get-started" ? t("steps.nav.getStarted") : ""}
            </span>
          </div>
          <div
            className={
              name == "travel-details"
                ? "nav-step-container marked"
                : "nav-step-container"
            }
          >
            <div
              className={
                name == "travel-details"
                  ? "nav-circle active-grow"
                  : "nav-circle"
              }
            >
              <span>2</span>
            </div>
            <br />
            <span className="step-details  mt-2">
              {name == "travel-details" ? t("steps.nav.travelDetails") : ""}
            </span>
          </div>
          <div
            className={
              name == "quotes"
                ? "nav-step-container marked"
                : "nav-step-container"
            }
          >
            <div
              className={
                name == "quotes" ? "nav-circle active-grow" : "nav-circle"
              }
            >
              <span>3</span>
            </div>
            <br />
            <span className="step-details mt-2">
              {name == "quotes" ? t("steps.nav.quotes") : ""}
            </span>
          </div>
          <div
            className={
              name == "auth"
                ? "nav-step-container marked"
                : "nav-step-container"
            }
          >
            <div
              className={
                name == "auth" ? "nav-circle active-grow" : "nav-circle"
              }
            >
              <span>4</span>
            </div>
            <br />
            <span className="step-details mt-2">
              {name == "auth" ? t("steps.nav.logIn") : ""}
            </span>
          </div>
          <div
            className={
              name == "prepare"
                ? "nav-step-container marked"
                : "nav-step-container"
            }
          >
            <div
              className={
                name == "prepare" ? "nav-circle active-grow" : "nav-circle"
              }
            >
              <span>5</span>
            </div>
            <br />
            <span className="step-details mt-2">
              {name == "prepare" ? t("steps.nav.prepareDocuments") : ""}
            </span>
          </div>
          <div
            className={
              name == "insured-details"
                ? "nav-step-container marked"
                : "nav-step-container"
            }
          >
            <div
              className={
                name == "insured-details"
                  ? "nav-circle active-grow"
                  : "nav-circle"
              }
            >
              <span>6</span>
            </div>
            <br />
            <span className="step-details mt-2">
              {name == "insured-details" ? t("steps.nav.detailsOfInsured") : ""}
            </span>
          </div>
          <div
            className={
              name == "beneficiary" || name == "group-details"
                ? "nav-step-container marked"
                : "nav-step-container"
            }
          >
            <div
              className={
                name == "beneficiary" || name == "group-details"
                  ? "nav-circle active-grow"
                  : "nav-circle"
              }
            >
              <span>7</span>
            </div>
            <br />
            <span className="step-details mt-2">
              {name == "beneficiary" ? t("steps.nav.beneficiaryDetails") : ""}
              {name == "group-details" ? t("steps.nav.groupDetails") : ""}
            </span>
          </div>
          <div
            className={
              name == "summary"
                ? "nav-step-container marked"
                : "nav-step-container"
            }
          >
            <div
              className={
                name == "summary" ? "nav-circle active-grow" : "nav-circle"
              }
            >
              <span>8</span>
            </div>
            <br />
            <span className="step-details mt-2">
              {name == "summary" ? t("steps.nav.summaryConfirmation") : ""}
            </span>
          </div>
          <div
            className={
              name == "payment"
                ? "nav-step-container marked"
                : "nav-step-container"
            }
          >
            <div
              className={
                name == "payment" ? "nav-circle active-grow" : "nav-circle"
              }
            >
              <span>9</span>
            </div>
            <br />
            <span className="step-details mt-2">
              {name == "payment" ? t("steps.nav.payment") : ""}
            </span>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Steps;
